import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SvgSpriteIcon} from '@selpia/shared/ui';
import {filter, interval, map} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-ai-button',
  imports: [CommonModule],
  templateUrl: './ai-button.component.html',
  styleUrl: './ai-button.component.scss',
})
export class AiButtonComponent {
  isLoading = input(false);

  $isAnimatedUp = interval(1000)
    .pipe(
      filter(() => this.isLoading()),
      map(x => x % 2 === 0),
      takeUntilDestroyed(),
    );

  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
